export default (t) => [
  {
    text: t('Image'),
    value: 'image',
    sortable: false,
    fixed: false,
    width: 70
  },
  {
    text: t('Name'),
    value: 'name',
    sortable: false,
    fixed: false
  },
  {
    text: t('Barcode'),
    value: 'barcode',
    sortable: false,
    fixed: false,
    width: 150
  },
  {
    text: t('Price'),
    value: 'price',
    sortable: false,
    fixed: false,
    width: 100
  },
  {
    text: t('Cost'),
    value: 'cost',
    sortable: false,
    fixed: false,
    width: 100
  },
  {
    text: t('Serving Size'),
    value: 'size_value',
    sortable: false,
    width: 125
  },
  {
    text: t('Sales Unit'),
    value: 'unit',
    sortable: false,
    width: 90
  }
];
